export default {
  // Auth
  'auth.welcome': 'Welcome back',
  'auth.subtitle': 'Sign in with your NexChat account to continue. Your messages are private and secure.',
  'auth.continue': 'Continue with NexChat',

  // General
  'app.name': 'NexChat',
  'app.loading': 'Loading…',
  'app.online': 'Online',
  'app.away': 'Away',
  'app.busy': 'Busy',
  'app.appear_offline': 'Appear Offline',

  // Sidebar
  'sidebar.conversations': 'Your conversations',
  'sidebar.new_conversation': 'New conversation',
  'sidebar.search': 'Search conversations…',
  'sidebar.loading': 'Loading rooms…',
  'sidebar.empty': 'No conversations yet.\nCreate one to get started.',
  'sidebar.select': 'Select a conversation from the sidebar or start a new one.',

  // Chat header
  'chat.encrypted': 'This conversation is end-to-end encrypted',
  'chat.loading': 'Loading messages…',
  'chat.no_messages': 'No messages yet',
  'chat.be_first': 'Be the first to say something!',
  'chat.voice_call': 'Voice call',
  'chat.video_call': 'Video call',
  'chat.pins': 'Pinned messages',
  'chat.starred': 'Starred messages',
  'chat.search': 'Search messages',

  // Input
  'input.placeholder': 'Message {room}…',
  'input.hint_send': 'Press {enter} to send · {shift_enter} for new line',
  'input.poll': 'Create poll',
  'input.gif': 'GIF & Stickers',
  'input.attach': 'Attach file',
  'input.schedule': 'Schedule message',
  'input.record': 'Hold or click to record voice message',
  'input.nexai': 'Ask NexAI',

  // Message actions
  'msg.reply': 'Reply',
  'msg.edit': 'Edit',
  'msg.delete': 'Delete',
  'msg.copy': 'Copy',
  'msg.forward': 'Forward',
  'msg.pin': 'Pin',
  'msg.unpin': 'Unpin',
  'msg.star': 'Star',
  'msg.unstar': 'Unstar',
  'msg.thread': 'Thread',
  'msg.translate': 'Translate',
  'msg.react': 'React',
  'msg.edited': 'edited',
  'msg.deleted': 'This message was deleted',

  // Thread panel
  'thread.title': 'Thread',
  'thread.replies': 'Replies',
  'thread.reply_placeholder': 'Reply in thread…',
  'thread.hint': 'Press Enter to reply · Shift+Enter for new line',
  'thread.summarise': '✨ Summary',
  'thread.summarising': '⏳ Summarising…',
  'thread.summary_title': '✨ AI Summary',
  'thread.not_enough': 'Not enough messages to summarise',

  // NexAI
  'nexai.placeholder': 'Ask NexAI…',
  'nexai.title': 'NexAI',
  'nexai.thinking': 'Thinking…',
  'nexai.clear': 'Clear',

  // Search
  'search.title': 'Search messages',
  'search.placeholder': 'Search messages, people, keywords…',
  'search.empty': 'Type to search messages',
  'search.no_results': 'No results found',
  'search.searching': 'Searching…',
  'search.results': '{count} result{plural}',

  // Profile dropdown
  'profile.edit': 'Edit Profile',
  'profile.theme': 'Theme',
  'profile.scheduled': 'Scheduled Messages',
  'profile.notifications': 'Notification Settings',
  'profile.logout': 'Sign Out',

  // Theme picker
  'theme.title': '🎨 Choose Theme',
  'theme.subtitle': '12 themes — dark and light variants for every style.',
  'theme.close': 'Close',

  // Notifications
  'notif.title': 'Notification Settings',
  'notif.browser': 'Browser notifications',
  'notif.browser_sub': 'Show desktop alerts when a new message arrives',
  'notif.sound': 'Sound notifications',
  'notif.sound_sub': 'Play a sound for new messages',
  'notif.volume': 'Volume',
  'notif.push': 'Push notifications',
  'notif.push_sub': 'Receive alerts even when NexChat tab is closed',
  'notif.push_enabled': '✓ Enabled',
  'notif.push_enable': 'Enable Push',
  'notif.push_enabling': 'Enabling…',
  'notif.sounds_title': 'Custom Sounds',
  'notif.preview': '▶ Preview',
  'notif.upload': '📎 Upload',
  'notif.clear': '✕ Clear',
  'notif.new_message': 'New message',
  'notif.mention': '@ Mention',
  'notif.dm': 'Direct message',
  'notif.ringtone': 'Ringtone (calls)',
  'notif.save': 'Save',
  'notif.close': 'Close',

  // New room modal
  'room.new_title': 'New Conversation',
  'room.dm_tab': '💬 Direct Message',
  'room.channel_tab': '# Channel',
  'room.dm_placeholder': '@username:nexchat.ethosserver.com',
  'room.channel_placeholder': 'e.g. general',
  'room.channel_label': 'Channel name',
  'room.dm_label': 'Username',
  'room.start_dm': 'Start conversation',
  'room.create_channel': 'Create channel',
  'room.cancel': 'Cancel',

  // Poll
  'poll.create': 'Create Poll',
  'poll.question': 'Question',
  'poll.question_placeholder': 'Ask a question…',
  'poll.option': 'Option {n}',
  'poll.add_option': '+ Add option',
  'poll.single': 'Single choice',
  'poll.multi': 'Multiple choice',
  'poll.anonymous': 'Anonymous',
  'poll.submit': 'Create Poll',
  'poll.cancel': 'Cancel',
  'poll.end': 'End poll',
  'poll.ended': 'Poll ended',
  'poll.votes': '{n} vote{plural}',

  // Schedule
  'schedule.title': '⏰ Schedule Message',
  'schedule.send_at': 'Send at',
  'schedule.quick': 'Quick select',
  'schedule.30min': '⚡ 30 min',
  'schedule.1h': '☕ 1 hour',
  'schedule.3h': '🕒 3 hours',
  'schedule.tomorrow': '📅 Tomorrow',
  'schedule.next_week': '📆 Next week',
  'schedule.confirm': 'Schedule Send',
  'schedule.cancel': 'Cancel',
  'schedule.list_title': '⏰ Scheduled Messages',
  'schedule.list_empty': 'No scheduled messages',
  'schedule.list_desc': 'Messages queued for delivery. Delivered within 30 seconds of scheduled time.',
  'schedule.now': 'Now: {time}',
  'schedule.in': 'in {time}',
  'schedule.sending_soon': 'sending soon…',
  'schedule.cancel_msg': '✕ Cancel',
  'schedule.close': 'Close',

  // Calls
  'call.status': 'Call in progress (new tab)',
  'call.rejoin': 'Rejoin',
  'call.end': 'End call',
  'call.incoming_voice': '📞 Incoming voice call',
  'call.incoming_video': '📹 Incoming video call',
  'call.accept': 'Accept',
  'call.decline': 'Decline',
  'call.started_voice': 'Started a voice call',
  'call.started_video': 'Started a video call',
  'call.ended': 'Call ended',
  'call.coming_soon': 'Calls coming soon — requires server upgrade',

  // Buttons
  'btn.save': 'Save',
  'btn.cancel': 'Cancel',
  'btn.close': 'Close',
  'btn.send': 'Send',
  'btn.delete': 'Delete',
  'btn.edit': 'Edit',
  'btn.confirm': 'Confirm',

  // Toasts
  'toast.copied': 'Copied to clipboard',
  'toast.message_deleted': 'Message deleted',
  'toast.profile_updated': 'Profile updated',
  'toast.status_set': 'Status set: {status}',
  'toast.offline_queued': 'Offline — message queued, will send when reconnected',
  'toast.back_online': 'Back online — sent {count} queued message{plural}',
  'toast.scheduled': 'Scheduled for {time}',
  'toast.poll_created': 'Poll created!',
  'toast.reminder_set': '⏰ Reminder set for {time}',
};
